import { createContext, useState } from "react";

const userContext = createContext();

export const UserState = (props) => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [activeType, setActiveType] = useState("all");

  const applyFilter = (role = "all") => {
    setActiveType(role);

    setFilteredUsers(
      role === "all" ? users : users.filter((u) => u.role_priv === role)
    );
  };

  return (
    <userContext.Provider
      value={{
        users,
        setUsers,
        filteredUsers,
        setFilteredUsers,
        userTypes,
        setUserTypes,
        activeType,
        setActiveType,
        applyFilter,
      }}
    >
      {props.children}
    </userContext.Provider>
  );
};

export default userContext;
